module.exports = "<a>\n    {{match.model.title}}\n    <div class=\"name\"\n         ng-bind-html=\"match.model.code | uibTypeaheadHighlight:query\"></div>\n</a>";


//////////////////
// WEBPACK FOOTER
// ./src/main/client/app/shared/course/selector/course-drop-down.html
// module id = 357
// module chunks = 0